import { useUser } from "./firestore/v2/user/useUser";

export const usePromotionCode = () => {
  const { user, isLoading, error } = useUser();

  return [user?.promotionCode, isLoading, error] as const;
};
